import { clientRecords } from '@atheneum/api'
import { extendObservable, computed } from 'mobx'

class AccountsAndOfficesStore {
  constructor (staticData, atheneumOfficeStore) {
    extendObservable(this, {
      staticData,
      atheneumOfficeStore,
      loading: null,
      error: null,
      parentAccountId: null,
      accounts: [],
      accountsCount: null,
      accountsPerPage: 10,
      page: 1,
      skip: computed(() => {
        return (this.page - 1) * this.accountsPerPage
      })
    })
  }

  loadAccounts (parentAccountId) {
    if (parentAccountId) {
      this.parentAccountId = parentAccountId
    }

    this.loading = true
    const getOptions = {
      skip: this.skip,
      limit: this.accountsPerPage,
      expanded: true
    }

    const staticData = this.staticData
    return clientRecords
      .getAccounts(this.parentAccountId, getOptions)
      .then(accountData => {
        this.accountsCount = accountData.count

        const formattedAccounts = accountData.rows.map(account => {
          const country = staticData.names.countries[account.countryId]
          const atheneumOffice = this.atheneumOfficeStore.atheneumOffices.find(
            atheneum => atheneum.id === account.atheneumOfficeId
          )
          const offices = account.offices.map(office => {
            const officeCountryId = office.address.countryId
            const country = staticData.names.countries[officeCountryId]
            return { ...office, country }
          })
          return {
            ...account,
            offices,
            country,
            atheneumOffice,
            expanded: false
          }
        })
        this.accounts.replace(formattedAccounts)
      })
      .catch(err => {
        console.error(err)
      })
      .then(() => {
        this.loading = false
      })
  }

  paginateAccounts = newPage => {
    this.page = newPage
    this.loadAccounts()
  }
}

export default AccountsAndOfficesStore
